import React from 'react';
import {Flex} from '@chakra-ui/react';
import {FilterControl} from './FilterControl';
import _ from 'lodash';
import {FilterGroup} from './useFilterGroup';

export const FilterGroupControl = ({
  filterGroup,
}: {
  filterGroup: FilterGroup;
}) => {
  const {availableOptions, filters, removeFilterControl, setFilterName} =
    filterGroup;

  if (filters.length === 0) {
    return null;
  }

  return (
    <Flex gap={4} flexDirection="column">
      {filters.map((filter, index) => (
        <FilterControl
          key={`${index}-${filter}`}
          selectedFilterName={filter}
          availableOptions={
            filter ? [filter, ...availableOptions] : availableOptions
          }
          onSetFilterName={(filterName) => {
            setFilterName(filterName, index);
          }}
          onRemove={() => {
            removeFilterControl(index);
          }}
        />
      ))}
    </Flex>
  );
};
